import { Component, OnInit } from '@angular/core';
import { RecordService } from 'app/main/services/record.service';
import { DatasetActionContainerService } from 'app/main/services/datasetACS';
import { Observable } from 'rxjs';
import { BasePageDirective } from '../base-page';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'app/main/services/app.service';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

export interface IListProducts{
	current_page: number;
	data: any[];
	first_page_url: string;
	from: number;
	last_page: number;
	last_page_url: string;
	next_page_url: string;
	path: string;
	per_page: number;
	prev_page_url: string;
	to: number;
	total: number;
}

@Component({
	selector: 'products-category',
	templateUrl: './category.component.html',
	styleUrls: ['./category.component.scss']
})
export class CategoryPageComponent extends BasePageDirective implements OnInit{

	_isLoading: boolean;
	_tripCategoryLanguageContent: any;
	_response: IListProducts;

	constructor(
		public recordService: RecordService, 
		public datasetACS: DatasetActionContainerService,
		public appService: AppService,
		protected activatedRoute: ActivatedRoute,
		protected router: Router,
		protected translate: TranslateService) {
		// init super constructor
		super(activatedRoute, router, appService, datasetACS, recordService, translate);

		this.datasetACS.init({
			datasetCode: 'trip_categories',
			datasetRoute: '/category/',
			datasetRS: this.recordService,
		});
	}

	ngOnInit(): void {
		super.ngOnInit();
	}

	onChangePage(page: number): void{
		this.recordService.extraParams = {page: page};
		this.load()
		.pipe(takeUntil(this._unsubscribeAll))
		.subscribe({
			next: response => {
				this.onLoaded(response);
			},
			error: response => {}
		});
	}

	protected load(): Observable<any>{
		this._isLoading = true;
		this.appService.loadingLanguages.next(true);

		return this.recordService.reload();
	}

	protected onLoaded(response): void{
		// mapping data
		this._response = <IListProducts>response['list-products'];
		// controlli per la categoria essendo la lingua basata su quest'ultima
		if (response.tripCategoryLanguageContent){
			this._tripCategoryLanguageContent = response.tripCategoryLanguageContent;
			// language
			this.translate.use(response.lang).subscribe(() => {
				this.appService.setLanguages(response.category.active_language_codes);
				this.appService.loadingLanguages.next(false);
			});
		} else {
			this.appService.setLanguages(['it', 'en']);
			this.translate.use('en');
		}
		this.appService.loadingLanguages.next(false);
		this._isLoading = false;
	}

	//#region properties
	get properties(): any{
		if (this._tripCategoryLanguageContent && this._tripCategoryLanguageContent.properties){
			return this._tripCategoryLanguageContent.properties;
		}
		return null;
	}

	get masterImage(): any{
		if (this.properties && this.properties.master_image_id){
			return this.properties.master_image_id.value;
		}
		return null;
	}

	get small_text(): any{
		if (this.properties && this.properties.small_text){
			return this.properties.small_text.value;
		}
		return null;
	}

	get canShowSlideContent(): boolean{
		if (this._tripCategoryLanguageContent && this._tripCategoryLanguageContent.description && this.small_text){
			return (this._tripCategoryLanguageContent.description !== null && this.small_text !== null);
		}
		return false;
	}

	get full_description(): any{
		if (this.properties && this.properties.full_description){
			return this.properties.full_description.value;
		}
		return null;
	}

	get thingsToDoImg(): any{
		if (this.properties && this.properties.things_to_do_image_id){
			return this.properties.things_to_do_image_id.value;
		}
		return null;
	}

	get thingsToDo(): any{
		if (this.properties && this.properties.things_to_do){
			return this.properties.things_to_do.value;
		}
		return null;
	}

	get canShowThingsToDo(): boolean{
		if (this._tripCategoryLanguageContent && this.thingsToDo && this.thingsToDoImg){
			return (this.thingsToDoImg !== null && this.thingsToDo.length);
		}
		return false;
	}

	get showPagination(): boolean{
		if(this._response.last_page && this._response.current_page && this._response.last_page > 1){
			return (this._response.last_page >= this._response.current_page);
		}
		return false;
	}

	getImgPath(tripPackage: any): any{
		if (tripPackage.master_image){
			return this.appService.getBaseServerAddress() + '/document_files/resize/1024x768/' + tripPackage.master_image;
		}
		return 'assets/img/1024x768.png';
	}
	//#endregion properties
}
